import initBooking from './modules/booking.js';
import BookingForm from './modules/bookingForm.js';
import HolidayForm from './modules/holiday-form.js';
import CertificateForm from './modules/certificateForm.js';
import initReviews from './modules/reviews.js';
import initHeader from './modules/header.js';
import initGames from './modules/games.js';
import GameTest from './modules/gametest.js';
import initLazyLoad from './modules/lazyload.js';
import initScrollAnimations from './modules/scroll-animations.js';

(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        initHeader();
        initBooking();
        initReviews();
        initGames();
        
        const bookingForm = new BookingForm();
        const certificateForm = new CertificateForm();
        const gameTest = new GameTest();
        const holidayForm = new HolidayForm();
        window.holidayForm = holidayForm;
        window.bookingForm = bookingForm;
        window.certificateForm = certificateForm;
        window.gameTest = gameTest;
        
        initLazyLoad();
        initScrollAnimations();
        
        window.addEventListener('load', () => {
            if (window.lazySizes && window.lazySizes.loader) {
                window.lazySizes.loader.checkElems();
            }
        });
        
        function smoothScrollToSection(hash) {
            if (!hash || typeof hash !== 'string') {
                return;
            }
            
            const target = document.querySelector(hash);
            if (!target) {
                return;
            }
            
            const header = document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 0;
            const targetRect = target.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            const targetOffset = targetRect.top + scrollTop - headerHeight;
            
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            const isAndroid = /Android/.test(navigator.userAgent);
            
            if (isIOS || isAndroid) {
                let currentScroll = scrollTop;
                const distance = targetOffset - currentScroll;
                const duration = 500;
                const startTime = Date.now();
                
                const easeInOutQuad = (t) => {
                    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                };
                
                const animateScroll = () => {
                    const elapsed = Date.now() - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const eased = easeInOutQuad(progress);
                    
                    currentScroll = scrollTop + (distance * eased);
                    window.scrollTo(0, currentScroll);
                    
                    if (progress < 1) {
                        requestAnimationFrame(animateScroll);
                    } else {
                        window.scrollTo(0, targetOffset);
                    }
                };
                
                requestAnimationFrame(animateScroll);
            } else {
                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            }
        }

        const bookingLinks = document.querySelectorAll('a[href="#booking"]');
        bookingLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                smoothScrollToSection('#booking');
            });
        });

        const greyCard = document.querySelector('.pricing__card--grey');
        
        if (greyCard) {
            greyCard.addEventListener('click', (e) => {
                e.preventDefault();
                const href = greyCard.getAttribute('href');
                if (href === '#contacts') {
                    smoothScrollToSection('#contacts');
                }
            });
        }
        
        if (window.location.hash) {
            const hash = window.location.hash;
            const anchor = hash.split('?')[0];
            
            if (anchor === '#booking' || anchor === '#contacts') {
                setTimeout(() => {
                    smoothScrollToSection(anchor);
                }, 300);
            }
        }
    });

})();
